import React from "react";
import { getPrettyDate } from "../lib/format";

// "1,3" is a perm of two selections.
const countPerms = (selection) => (selection.match(/,/g) || []).length + 1;

// "-" marks a match the tipster left out, where only some matches are picked.
const NOT_PICKED = "-";

const leagueTitle = (tips, item) => (tips.renameLeague ? item.league_title.replace(tips.renameLeague.from, tips.renameLeague.to) : item.league_title);

const permSelection = (selection) => (selection == null || selection === NOT_PICKED ? "_" : selection);

// The Suggested Perm as text nodes: Soccer 13X's as one string, the others as
// each selection and " x " separately, split where permSplits says.
const permNodes = (tips, item, matchNumbers) => {
  const shown = (tips.permMatches ?? matchNumbers).map((n) => item[`selection${n}`]);
  if (tips.pickedMatchesOnly) return [shown.map(permSelection).join(" x ")];
  const splits = tips.permSplits ?? [];
  return shown.flatMap((selection, i) => {
    if (i === 0) return [selection];
    return splits.includes(i) ? [" x", " ", selection] : [" x ", selection];
  });
};

// The BET NOW link's selection parameter, without the trailing ",WT,".
const betSelection = (tips, selections) => {
  if (!tips.pickedMatchesOnly) return selections.map(String).join(",WT,");
  return selections.flatMap((selection, i) => (selection === NOT_PICKED ? [] : [`${i + 1},${selection}`])).join(",WT,");
};

// One Program's Tips, rendered from its Pool Type's config (src/poolTypes.js).
const Tips = ({ poolType, item }) => {
  const { tips } = poolType;
  const matchNumbers = Array.from({ length: poolType.matchCount }, (_, i) => i + 1);
  const selections = matchNumbers.map((n) => item[`selection${n}`]);
  const cost = selections.reduce((total, selection) => total * countPerms(selection), tips.stake);
  return (
    <div>
      <a href="/#" name={item.RowKey + item.program_code + item.league_title.replace(/ /g, "")}>
        <div className="pooldateindicator4R">
          {getPrettyDate(item.RowKey)} - {leagueTitle(tips, item)}
          <span style={{ float: "right" }}>{tips.tipster ?? "Expert"}</span>
        </div>
      </a>
      <table className="toptipstable">
        {/* Numbered M1 to Mn even for Soccer 8, whose Results use its matchLabels. */}
        {matchNumbers.map((n) => (
          <tr key={n}>
            <td className="bold">{`M${n}`}</td>
            <td className="bold" style={{ textAlign: "left" }}>
              {item[`match${n}`]}
            </td>
            <td>{item[`selection${n}`]}</td>
          </tr>
        ))}
        <tr>
          <td></td>
          <td>
            <span style={{ float: "left" }}>
              <strong>Suggested Perm:</strong> {permNodes(tips, item, matchNumbers)} <strong>Cost: R{cost}.00</strong>
            </span>
            <a
              target="_blank"
              rel="noopener noreferrer"
              style={{ float: "right", margin: 0 }}
              className="button button4R tiny betnowbutton"
              href={`https://www.tab.co.za/tabs/soccer/${item.RowKey}/${item.program_code}/${item.race}?selection=${betSelection(tips, selections)}&game=soccer&type=${tips.betType}&channel=9`}
            >
              BET NOW
            </a>
          </td>
        </tr>
      </table>
    </div>
  );
};

export default Tips;
